module.exports = __webpack_public_path__ + "img/75h85.86c1eafc.svg";